<template>
  <div>
    <app-popup :active.sync="active" title="Генерация плана наряд-задание" class="generate-issues-plan-popup"
               width="620px">
      <div class="generate-issues-plan-popup__row">
        <app-v-select use-dynamic-key :options="houses" v-model="selectedBuildingsId" label="Дом" :clearable="false"
                      :searchable="true" select-label="address" append-to-body :disabled="isGenerating">
          <template slot="selected-option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              {{ option.address }}
            </div>
          </template>
          <template slot="option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              {{ option.address }}
            </div>
          </template>
          <template slot="no-options">
            Дома не найдены
          </template>
        </app-v-select>
      </div>
      <div class="generate-issues-plan-popup__row">
        <app-v-select :options="users" :reduce-function="option => option"
                      :clearable="true" label="Пользователи"
                      :closeOnSelect="false"
                      :useDynamicKey="false"
                      :disabled="isGenerating"
                      :searchable="true" v-model="selectedUsers" style="width: 100%" multiple append-to-body
                      :danger.sync="selectedUsersError" danger-text="Выберите хотя бы одного пользователя">
          <template slot="selected-option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                          class="generate-issues-plan-popup__user-info-avatar" size="20px" />
              <div class="generate-issues-plan-popup__user-info-name">{{ option.name }}</div>
            </div>
          </template>
          <template slot="option" slot-scope="option">
            <div style="display: flex; align-items: center;">
              <app-avatar :img="$options.filters.imgPath(option.avatar)" :name="option.name"
                          class="generate-issues-plan-popup__user-info-avatar" size="20px" />
              <div class="generate-issues-plan-popup__user-info-name">{{ option.name }}</div>
            </div>
          </template>
          <template slot="no-options">
            Пользователи не найдены
          </template>
        </app-v-select>
      </div>

      <div class="generate-issues-plan-popup__actions">
        <app-button color="success" v-if="!isGenerating" @click="startGenerate">Сгенерировать</app-button>
        <div class="generate-issues-plan-popup__loading" v-else>
          <div class="block-loading" />
          <div class="generate-issues-plan-popup__loading-text">Идет генерация планов</div>
        </div>
      </div>

    </app-popup>
  </div>
</template>

<script>

export default {
  name:     "GeneratePlanPopup",
  data() {
    return {
      active:              false,
      users:               [],
      selectedBuildingsId: null,
      selectedUsers:       [],
      selectedUsersError:  false,
      isGenerating:        false,
    };
  },
  computed: {
    houses() {
      return this.$store.getters['appUser/housesByPermission']('issues', 'access');
    },
  },
  methods:  {
    open() {
      this.active = true;
      this.selectedUsersError = false;
      this.selectedBuildingsId = this.$store.getters['appUser/selectedHouse'].id;
    },
    async getUsers() {
      try {
        let { data } = await this.$http.get('tasks-performers');
        this.selectedUsersError = false;
        this.selectedUsers = [];
        this.users = data;
      } catch (e) {
        this.users = [];
      }
    },
    generate( building, user ) {
      return new Promise(async ( resolve, reject ) => {
        try {
          let { data } = await this.$http.get('tasks-filtered', {
            params: {
              buildings_id: [building.id],
              performer_id: [user.id],
              status_id:    Object.values(this.$store.getters['common/tasks/statuses']).map(status => status.id).filter(status => ![5, 6].includes(status)),
            },
          });
          await this.generatePdf(data.length ? data : [{ name: '' }], user, building);
          resolve(true);
        } catch (e) {
          reject(e);
        }
      });
    },
    async generatePdf( tasks, performer, building ) {

      let date = new Date();

      let tableRows = tasks;
      tableRows = tableRows.map(( row, index ) => {
        let additional = row.additional ? JSON.parse(row.additional) : {};

        return [
          {
            text:      index + 1,
            alignment: 'right',
            fontSize:  10,
          },
          {
            text:     row.name || row.description,
            fontSize: 10,
          },
          {
            text:     row.owner ? row.owner.name : '',
            fontSize: 10,
          },
          {
            text:     additional.phone ? additional.phone : '-',
            fontSize: 10,
          },
          {
            text: '',
          },
          {
            text: '',
          },
          {
            text: '',
          },
          {
            text: '',
          },
        ];
      });
      let tableHeaders = ['№', 'Наименование', 'Автор', 'Телефон для связи', 'Используемые материалы', 'Ед. изм.', 'Кол-во', 'Примечание'];
      tableHeaders = tableHeaders.map(header => {
        return {
          text:      header,
          fontSize:  10,
          alignment: 'center',
          bold:      true,
        };
      });
      var dd = {
        content: [
          { text: 'План задание №____', alignment: 'center', bold: true, fontSize: 14 },
          {
            margin: [0, 10, 0, 0],
            text:   [
              {
                text: 'Исполнитель: ',
              },
              {
                text:       performer.name,
                decoration: 'underline',
                bold:       true,
              },
            ],
          },
          {
            margin: [0, 3, 0, 0],
            text:   [
              {
                text: 'Дата: ',
              },
              {
                text:       `"${this.$options.filters.moment(date, 'DD')}"`,
                decoration: 'underline',
                bold:       true,
              },
              {
                text:       ` ${this.$options.filters.moment(date, 'MMMM')}`,
                decoration: 'underline',
                bold:       true,
              },
              {
                text:       ` ${this.$options.filters.moment(date, 'YYYY')}г.`,
                decoration: 'underline',
                bold:       true,
              },
            ],
          },
          {
            margin: [0, 3, 0, 0],
            text:   [
              {
                text: 'Адрес: ',
              },
              {
                text:       building.address,
                decoration: 'underline',
                bold:       true,
              },
            ],
          },
          {
            margin: [0, 20, 0, 0],
            style:  'tableExample',
            table:  {
              widths: [8, '*', '*', '*', 80, 30, 30, '*'],
              body:   [
                tableHeaders,
                ...tableRows,
              ],
            },
          },
          {
            margin: [0, 20, 0, 0],
            text:   [
              {
                text:     'Выдал: ',
                fontSize: 10,
              },
              {
                text:       (new Array(104)).fill(' ').join(''),
                decoration: 'underline',
              },
              {
                text:     ' / ',
                fontSize: 10,
              },
              {
                text:       (new Array(50)).fill(' ').join(''),
                decoration: 'underline',
              },
            ],
          },
          {
            margin: [0, 10, 0, 0],
            text:   [
              {
                text:     'Получил: ',
                fontSize: 10,
              },
              {
                text:       (new Array(100)).fill(' ').join(''),
                decoration: 'underline',
              },
              {
                text:     ' / ',
                fontSize: 10,
              },
              {
                text:       (new Array(50)).fill(' ').join(''),
                decoration: 'underline',
              },
            ],
          },
        ],
      };

      let fileName = `План наряд-задание для ${performer.name} от ${this.$options.filters.moment(date)}.pdf`;

      Promise.all([
        import("pdfmake/build/pdfmake"),
        import("pdfmake/build/vfs_fonts"),
      ]).then(( [{ default: pdfMake }, { default: pdfFonts }] ) => {
        console.log(pdfMake, pdfFonts);
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.createPdf(dd).download(fileName);
      });
    },
    async startGenerate() {
      if (!this.selectedUsers.length) {
        this.selectedUsersError = true;
        return false;
      }

      this.isGenerating = true;

      this.selectedBuildings = this.houses.find(h => h.id === this.selectedBuildingsId);

      try {
        if (!this.selectedBuildings) {
          this.isGenerating = false;
          this.$vs.notify({ color: 'danger', 'title': 'Произошла ошибка', 'text': 'Не найден дом' });
          return false;
        }
        for await (let user of this.selectedUsers) {
          await this.generate(this.selectedBuildings, user);
        }
        this.isGenerating = false;
      } catch (e) {
        if (e.response) {
          if (e.response.status === 403) {
            this.$vs.notify({ color: 'danger', title: 'Ошибка доступа', text: 'Недостаточно прав' });
          } else {
            this.$vs.notify({ color: 'danger', title: 'Ошибка сервера', text: 'Повторите позже' });
          }
        } else {
          this.$vs.notify({ color: 'danger', title: 'Произошла ошибка', text: 'Неизвестная ошибка' });
        }
        this.isGenerating = false;
      }
    },
  },
  created() {
    this.getUsers();
  },
};
</script>

<style lang="scss">
.generate-issues-plan-popup {
  &__user-info {
    &-avatar {
      flex-shrink: 0;
      margin-right: 5px;
    }

    &-name {
      white-space: nowrap;
    }
  }

  &__row {
    margin-bottom: 15px;
  }

  &__actions {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__loading {
    display: flex;
    align-items: center;

    .block-loading {
      flex: 0;
      margin: 0 10px 0 0;

      &::before {
        width: 18px;
        height: 18px;
      }
    }

    &-text {
      font-size: 12px;
      font-weight: 500;
      user-select: none;
      line-height: 1;
    }
  }
}
</style>
